import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components/ui/button';

interface PageHeaderProps {
  title: string;
  description?: string;
  onAdd?: () => void;
  addLabel?: string;
  /** Optional extra action rendered before the primary Add button — for
   * pages that need a second entry point (e.g. "Bulk Upload" next to "New
   * Intake"). Purely additive; existing single-action usages are unaffected. */
  secondaryAction?: React.ReactNode;
}

export function PageHeader({
  title,
  description,
  onAdd,
  addLabel = 'Add New',
  secondaryAction,
}: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>
      {(secondaryAction || onAdd) && (
        <div className="mt-3 flex items-center gap-2 sm:mt-0">
          {secondaryAction}
          {onAdd && (
            <Button onClick={onAdd} className="min-h-[44px]">
              <FontAwesomeIcon icon={faPlus} className="mr-2 h-3.5 w-3.5" />
              {addLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
